
import { defineComponent, onBeforeUnmount, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  setup() {
    const store = useStore();
    const businesses = computed(() => store.getters.getBusinesses);
    store.commit(Mutations.SET_TOOLBAR_BUTTON, {
      shouldShow: true,
      title: "Create",
      url: "/create-investment-opportunity",
    });
    const truncateText = (text, limit) => {
      return (text ?? "")?.substr(0,limit)
    }
    onMounted(() => {
      setCurrentPageBreadcrumbs("Businesses", []);
      store.dispatch(Actions.GET_FOUNDER_BUSINESSES, {
        page: 1,
        perPage: 10,
      });
    });
    onBeforeUnmount(() => {
      store.commit(Mutations.SET_TOOLBAR_BUTTON, {
        shouldShow: false,
        title: "",
        url: "",
      });
    });
    return {
      truncateText,
      businesses,
    };
  },
});
